import moment from 'moment'
import { useIntl } from 'react-intl'

import { PAGE_NAME } from '../../../../../../components/OrderStepsHeader/constants'
import SkeletonLoader from '../../../../../../components/SkeletonLoader/SkeletonLoader'
import Tooltip from '../../../../../../components/Tooltip/Tooltip'
import Typography from '../../../../../../components/Typography/Typography'

import TooltipWindowNew from 'components/Windows/TooltipWindow/TooltipWindowNew'
import './HallDetails.scss'
import hocHallDetails from './hocHallDetails'

const HallDetails = ({ page, movie, cinemaType, hallInfoData }) => {
    const intl = useIntl()

    // TODO foto salu transform to react-intl + show picture on hover?

    return (
        <div className={'hall-details h-100 d-flex flex-column justify-content-center'}>
            <div className={'hall-details--time d-flex text-nowrap'}>
                <Typography variant={'label'} className={'text-capitalize'}>
                    {movie?.start ? moment(movie?.start).format('dddd DD. MM.') : <SkeletonLoader />}
                </Typography>
                <Typography variant={'sectionHeadline'}>
                    {movie?.start || movie?.venue ? (
                        intl.formatMessage(
                            { id: 'hall.hallHeader.dateAndVenue' },
                            { date: moment(movie?.start ?? null).format('HH:mm'), venue: movie?.venue ?? 'N/A' }
                        )
                    ) : (
                        <SkeletonLoader />
                    )}
                </Typography>
            </div>

            {page === PAGE_NAME.hall && (
                <div className={'d-flex align-items-center gap-2'}>
                    <Typography variant={'label'}>
                        {intl.formatMessage({ id: `hall.hallHeader.hallPicture` })}
                    </Typography>
                    <Tooltip
                        id={`${cinemaType}-mobile`}
                        className={'hall-details--tooltip-mobile'}
                        content={
                            <TooltipWindowNew
                                imgUrl={hallInfoData?.imageMobile?.[0]?.url}
                                title={hallInfoData?.cinemaHallTitle}
                                subtitle={hallInfoData?.cinemaHallDescription}
                            />
                        }
                        placement={'bottom'}
                        clickable
                    />
                    <Tooltip
                        id={cinemaType}
                        className={'hall-details--tooltip-desktop'}
                        content={
                            <TooltipWindowNew
                                imgUrl={hallInfoData?.imageMobile?.[0]?.url}
                                title={hallInfoData?.cinemaHallTitle}
                                subtitle={hallInfoData?.cinemaHallDescription}
                            />
                        }
                        placement={'left'}
                    />
                </div>
            )}
        </div>
    )
}

export default hocHallDetails(HallDetails)
